/**
 * DashboardDevices entity class
 */

/**
 * DashboardDevicesFactory
 * returns DashboardDevices entity class
 *
 * @class DashboardDevicesFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DashboardDevices} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DashboardDevicesFactory
 */
/* @ngInject */
export default function DashboardDevicesFactory ($http, Entity) {
  /* === DashboardDevices class === */

  /**
   * DashboardDevices model
   *
   * @class DashboardDevices
   * @classdesc DashboardDevices model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing DashboardDevices entity fields
   * @return {models.DashboardDevices} DashboardDevices entity
   */
  function DashboardDevices () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DashboardDevices.prototype = Object.create(Entity.prototype)
  DashboardDevices.prototype.constructor = DashboardDevices

  /* === DashboardDevices instance methods & fields === */

  Object.assign(DashboardDevices.prototype, {

    /**
     * instance fields
     *
     * @memberof models.DashboardDevices#
     * @type {Object}
     */
    _fields: {
      mapPoints: {}
    },

    /**
     * Url template
     *
     * @memberof models.DashboardDevices#
     * @type {String}
     */
    _urlTemplate: 'api/dashboard/widgets/devices',

    /**
     * Public url template
     *
     * @memberof models.DashboardDevices#
     * @type {String}
     */
    _publicUrlTemplate: 'dashboard/widgets/devices',

    /**
     * Get devices map data
     *
     * @memberof models.DashboardDevices#
     * @private
     */
    _loadMap: function (params) {
      return DashboardDevices.load({
        params,
        url: '\\map'
      }, { points: null })
        .then((points) => { this.map = points })
    },

    /**
     * Get csv map data
     *
     * @memberof models.DashboardDevices#
     * @private
     */
    _loadCSVMap: function (params) {
      return DashboardDevices.load({
        ...params,
        url: '\\csv\\map'
      })
    }
  })

  /* === DashboardDevices static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DashboardDevices, Entity)
  DashboardDevices._name = 'DashboardDevices'
  DashboardDevices.init()

  /**
   * Load extra for entity with filter payload
   *
   * @param url
   */
  DashboardDevices.loadPayloadExtra = (url) =>
    DashboardDevices.loadExtra(url)
      .then((data) => // Note: maybe use q.decorator
        data && data.payload !== undefined
          ? data.payload
          : null
      )

  return DashboardDevices
}
